{
  "appName": "SmartAss AI",
  "actions": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "create": "Erstellen",
    "submit": "Absenden",
    "reset": "Zurücksetzen",
    "search": "Suchen",
    "filter": "Filtern",
    "viewAll": "Alle anzeigen",
    "viewDetails": "Details anzeigen",
    "back": "Zurück",
    "next": "Weiter",
    "close": "Schließen",
    "confirm": "Bestätigen",
    "loading": "Wird geladen...",
    "retry": "Erneut versuchen"
  },
  "status": {
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "scheduled": "Geplant",
    "confirmed": "Bestätigt",
    "pending": "Ausstehend",
    "inProgress": "In Bearbeitung",
    "completed": "Abgeschlossen",
    "cancelled": "Storniert",
    "noShow": "Nicht erschienen",
    "converted": "Konvertiert"
  },
  "errors": {
    "somethingWentWrong": "Entschuldigung, etwas ist schiefgelaufen",
    "pageNotFound": "Seite nicht gefunden",
    "unauthorized": "Unbefugter Zugriff",
    "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut.",
    "unknown": "Unbekannter Fehler"
  },
  "table": {
    "client": "Kunde",
    "service": "Dienstleistung",
    "time": "Uhrzeit",
    "status": "Status",
    "location": "Standort",
    "actions": "Aktionen",
    "source": "Quelle",
    "lastInteraction": "Letzte Interaktion",
    "noData": "Keine Daten verfügbar"
  },
  "copyright": "© {{year}} SmartAss AI. Alle Rechte vorbehalten.",
  "language": "Sprache",
  "or": "Oder",
  "noContactInfo": "Keine Kontaktdaten",
  "anonymous": "Anonym",
  "tbd": "Noch offen",
  "signIn": "Anmelden",
  "userMenu": {
    "adminPanel": "Admin-Bereich",
    "clientView": "Mandantenansicht",
    "customerView": "Endkundenansicht",
    "manage": "Verwalten",
    "dashboard": "Dashboard",
    "home": "Startseite",
    "signOut": "Abmelden",
    "signingOut": "Abmeldung läuft...",
    "logoutSuccess": "Erfolgreich abgemeldet",
    "profile": "Profil",
    "switchOrganization": "Organisation wechseln",
    "roleBadgeAdmin": "Administrator",
    "roleBadgeDeveloper": "Entwickler"
  },
  "ui": {
    "darkMode": {
      "dark": "Dunkel",
      "light": "Hell",
      "switchToLight": "Zum hellen Modus wechseln",
      "switchToDark": "Zum dunklen Modus wechseln"
    },
    "autoRefresh": {
      "label": "Automatische Aktualisierung",
      "lastUpdated": "Zuletzt: {{time}}",
      "on": "AN",
      "off": "AUS"
    },
    "adminClientSelector": {
      "view": "Tenant:",
      "selectClient": "Kunde auswählen"
    },
    "adminCompanySelector": {
      "view": "Unternehmen:",
      "selectCompany": "Unternehmen auswählen",
      "allCompanies": "Alle Unternehmen"
    },
    "adminCustomerSelector": {
      "view": "Kunde:",
      "selectCustomer": "Kunden auswählen"
    },
    "sidebar": {
      "expandSidebar": "Seitenleiste erweitern",
      "collapseSidebar": "Seitenleiste einklappen"
    },
    "tenantSelector": {
      "title": "Organisation auswählen",
      "description": "Wählen Sie die Organisation, auf die Sie zugreifen möchten:",
      "company": "Unternehmen",
      "tenant": "Tenant",
      "tenantLevel": "Tenant (Organisation)",
      "companyLevel": "Unternehmen (Team)",
      "preferred": "Bevorzugt",
      "loadingOrganizations": "Ihre Organisationen werden geladen...",
      "noOrganizationsTitle": "Keine Organisationen gefunden",
      "noOrganizationsDescription": "Sie haben noch keinen Zugang zu einer Organisation. Bitte kontaktieren Sie Ihren Administrator.",
      "availableOrganizations": "Verfügbare Organisationen ({{count}})",
      "organizationHint": "Wählen Sie einen Tenant für breiten Zugang oder ein Unternehmen für spezifischen Zugang. Hierarchie: Tenant → Unternehmen.",
      "selectToContinue": "Wählen Sie Ihre Organisation, um fortzufahren.",
      "cancel": "Abbrechen",
      "continue": "Weiter",
      "switchError": "Organisation wechseln fehlgeschlagen. Bitte versuchen Sie es erneut."
    }
  },
  "speechToText": {
    "voiceInput": "Spracheingabe",
    "stopVoiceInput": "Spracheingabe stoppen",
    "listening": "Zuhören...",
    "permissionDenied": "Mikrofonzugriff ist erforderlich. Bitte erlauben Sie den Zugriff und versuchen Sie es erneut.",
    "noSpeech": "Keine Sprache erkannt. Versuchen Sie es erneut oder geben Sie Ihre Nachricht ein.",
    "unsupported": "Spracheingabe in diesem Browser nicht verfügbar"
  },
  "structuredNote": {
    "structureWithAi": "Mit KI strukturieren",
    "updateStructure": "KI-Struktur aktualisieren",
    "editNote": "Notiz bearbeiten",
    "originalNote": "Originalnotiz",
    "structuredNote": "KI-strukturierte Notiz",
    "emptyStructured": "Noch kein strukturierter Inhalt.",
    "addItem": "Eintrag hinzufügen",
    "addNextStep": "Nächsten Schritt hinzufügen",
    "sections": {
      "keyTakeaways": "Wichtige Erkenntnisse / Notizen",
      "agreementsDecisions": "Vereinbarungen / Entscheidungen",
      "nextSteps": "Nächste Schritte / Aufgaben"
    },
    "labels": {
      "responsible": "Verantwortlich",
      "deadline": "Frist"
    },
    "placeholders": {
      "keyTakeaway": "Wichtige Erkenntnis eingeben...",
      "agreement": "Vereinbarung oder Entscheidung eingeben...",
      "task": "Aufgabe",
      "responsible": "Verantwortlich (optional)",
      "deadline": "Frist (optional)"
    },
    "regenerateConfirm": {
      "title": "Strukturierte Notiz ersetzen?",
      "message": "Die KI-strukturierte Notiz enthält manuelle Änderungen. Eine neue Struktur kann diese ersetzen. Möchten Sie fortfahren?",
      "continue": "Fortfahren"
    },
    "loading": {
      "title": "Notiz wird strukturiert…",
      "description": "Die KI organisiert Erkenntnisse, Entscheidungen und nächste Schritte. Dies kann einige Sekunden dauern."
    },
    "errors": {
      "generic": "Notiz konnte nicht strukturiert werden. Bitte versuchen Sie es erneut."
    }
  },
  "tenantInviteModal": {
    "title": "Registrierungslink erstellen",
    "description": "Wählen Sie eine Rolle für den Einladungslink. Benutzer, die sich mit diesem Link registrieren, erhalten die gewählte Rolle.",
    "roleLabel": "Rolle",
    "roleRequired": "Bitte Rolle auswählen",
    "rolePlaceholder": "Rolle auswählen",
    "roleTooltip": "Die Rolle, die Benutzern bei der Registrierung mit diesem Link zugewiesen wird",
    "roleOwner": "Eigentümer",
    "roleEmployee": "Mitarbeiter",
    "generateLink": "Link erstellen",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "tokenSuccess": "Einladungslink erstellt",
    "tokenError": "Einladungslink konnte nicht erstellt werden: {{error}}",
    "successTitle": "Einladungslink erstellt",
    "successDescription": "Teilen Sie diesen Link mit der Person, die Sie einladen möchten. Der Link läuft in 5 Tagen ab.",
    "linkDetails": "Link-Details",
    "inviteLink": "Einladungslink",
    "tenantRoleLabel": "Tenant-Rolle",
    "clientIdLabel": "Client-ID",
    "companyIdLabel": "Unternehmens-ID",
    "expiresAt": "Läuft ab am",
    "registrationUrl": "Registrierungs-URL",
    "copyRegistrationLink": "Registrierungslink kopieren",
    "copyHint": "Kopieren",
    "copied": "Kopiert!",
    "copySuccess": "Link in die Zwischenablage kopiert",
    "securityNotice": "Sicherheitshinweis",
    "securityDescription": "Diese Registrierungs-URL wird nur einmal angezeigt. Kopieren Sie sie vor dem Schließen. Jeder mit dieser URL kann sich registrieren und mit der angegebenen Rolle beitreten."
  },
  "tenantRoles": {
    "OWNER": {
      "label": "Inhaber",
      "description": "Volle Verwaltungsrechte: Mitarbeiter, Konfiguration und Einladungen"
    },
    "EMPLOYEE": {
      "label": "Mitarbeiter",
      "description": "Operativer Zugriff: Termine, Leads und Ressourcen"
    },
    "CUSTOMER": {
      "label": "Kunde",
      "description": "Portalzugang als Kunde dieses Mandanten; keine Firmenzugehörigkeit"
    }
  },
  "relativeTime": {
    "justNow": "gerade eben",
    "minutes": "vor {{count}} Min.",
    "hours": "vor {{count}} Std.",
    "days": "vor {{count}} T.",
    "months": "vor {{count}} Mon.",
    "years": "vor {{count}} J."
  }
}
